import { RSAA } from 'redux-api-middleware'
import * as R from 'ramda'
import { getApiPath } from 'sidecar-utility-library'

import { initialState, types } from 'store/Checks'

export const fetchCheckStatus = ({ checkUuid }) => ({
  [RSAA]: {
    endpoint: getApiPath('exp', `checks/${checkUuid}`),
    method: 'GET',
    types: [
      types.FETCH_CHECK_STATUS_REQUEST,
      types.FETCH_CHECK_STATUS_SUCCESS,
      types.FETCH_CHECK_STATUS_ERROR,
    ],
  },
})

export const initializeCheckStatus = () => ({
  type: types.INITIALIZE_CHECK_STATUS,
})

export const setCheckStatusBusy = busy => ({
  type: types.SET_CHECK_STATUS_BUSY,
  payload: busy,
})

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    case types.FETCH_CHECK_STATUS_REQUEST: {
      return {
        ...state,
        checkDetails: {
          ...state.checkDetails,
          busy: true,
          error: null,
        },
      }
    }
    case types.FETCH_CHECK_STATUS_SUCCESS: {
      return {
        ...state,
        checkDetails: {
          ...state.checkDetails,
          busy: false,
          entity: payload,
        },
      }
    }
    case types.FETCH_CHECK_STATUS_ERROR: {
      return {
        ...state,
        checkDetails: {
          ...state.checkDetails,
          busy: false,
          error: R.pathOr(
            'Something went wrong',
            ['response', 'message'],
            payload,
          ),
        },
      }
    }
    case types.SET_CHECK_STATUS_BUSY: {
      return {
        ...state,
        checkDetails: {
          ...state.checkDetails,
          busy: payload,
        },
      }
    }
    case types.INITIALIZE_CHECK_STATUS: {
      return {
        ...initialState,
      }
    }

    default:
      return state
  }
}
